module.exports = __webpack_public_path__ + "img/loan_settle_icon.3f905f16.svg";